import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Colors, Icon } from '@doordash/design-language'

import { DeliveryIssueStatus } from '../../../../models/types'

type StyledListCellMenuItemProps = {
  status: DeliveryIssueStatus
}

export const StyledListCellMenuItem = styled.div`
  background-color: ${(props: StyledListCellMenuItemProps) =>
    props.status === DeliveryIssueStatus.Unread
      ? Icon.Colors.SystemBlue5
      : Icon.Colors.SystemWhite};
`

export const StyledStatusIndicator = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const UndecoratedLink = styled(Link)`
  text-decoration: none;
  display: block;
`

export const StickyTop = styled.div`
  position: sticky;
  top: 0;
  background-color: ${Colors.PageBackgroundPrimary};
`
